// import the required animation functions from the angular animations module
import { animate, AnimationTriggerMetadata, state, style, transition, trigger } from '@angular/animations';

export const widthExpandAnimation = (duration: number): AnimationTriggerMetadata =>
    trigger('widthExpand', [
        state('in', style({ width: '100%' })),
        transition(':enter', [style({ width: '0%' }), animate(`${duration}ms ease-in-out`)]),
        transition(':leave', [animate(`${duration}ms ease-in-out`, style({ width: '0%' }))]),
    ]);
